// CONVERT BALANCE v2 — batch 3's rebuild of screens/ConvertBalance.tsx's route (UI rebuild; drawn when lib/ui-v2.ts
// switches batch 3 on). /parties/:slug/convert: the page head (its routes.ts title) around the party form
// (components/v2/convert/PartyForm — the state machine is ConvertBalanceForm's, copied verbatim).
//
// KEPT FROM ConvertBalance(): the party read on the party page's key (arriving from it is a cache hit); the screen is
// replaced only when there is nothing to show — a failed read with nothing cached, or the first read on its way — so a
// refresh that fails after a posting keeps the form and its outcome; a desk account's slug gets no title (the form says
// it is a desk account and links to it).
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { useDesk } from '../../components/DeskSwitch';
import { PageHead, Pending, ReadFailed } from '../../components/v2/kit';
import { PartyConvertForm } from '../../components/v2/convert/PartyForm';

export function ConvertPartyV2() {
  const { slug } = useParams<{ slug: string }>();
  const [entity] = useDesk();

  // Same key as the party page, so arriving from it is a cache hit.
  const q = useQuery({
    queryKey: ['party', slug, entity],
    queryFn:  () => api.partyDetail(slug!, entity),
    enabled:  !!slug,
  });

  if (q.isError && !q.data) {
    return (
      <>
        <PageHead title="Convert balance" />
        <ReadFailed what="this party" error={q.error} onRetry={() => void q.refetch()} tone="bad" />
      </>
    );
  }
  if (!q.data) return <><PageHead title="Convert balance" /><Pending /></>;

  // A rail is not a party (the form says so, and shows no title for it).
  const ownAccount = q.data.party.party_type === 'own_account';
  return (
    <>
      {!ownAccount && <PageHead title="Convert balance" />}
      <PartyConvertForm slug={slug!} entity={entity} />
    </>
  );
}
